module.exports = "./img/desktop_logo.e9a4e2e.png";